import { useProjectParams } from '@hooks/useProjectParams';
import { RequestStatus } from 'features/request/requestSlice';
import { useProjectData } from 'hooks/useProjectData';
import { ProjectPageLayout } from 'pages/Project/Common/Layouts/ProjectPageLayout';
import { Loader } from 'uikit';

import { useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { ContractUpdateToolbar } from '../../../Common/Contract/ContractUpdateToolbar/ContractUpdateToolbar';
import { useContractData } from '../hooks/useContractData';
import { parseContractData } from '../utils';

import { ContractUpdateForm } from './ContractUpdateForm';

export const ContractUpdate = () => {
    const { id: projectId, methodology } = useProjectParams();

    const { state }: { state: { contractId?: number } } = useLocation();

    const { projectData, projectDataStatus } = useProjectData(projectId);

    const [getContractData, getContractStatus, , makeContractDataRequest] = useContractData(
        state?.contractId || projectData?.contractId,
    );

    const breadCrumbsItems = useMemo(
        () => [
            {
                label: projectData?.name,
                href: `/projects/${methodology}/${projectId}`,
            },
        ],
        [methodology, projectData?.name, projectId],
    );

    const defaultValues = useMemo(() => {
        const data = parseContractData(getContractData);

        return {
            ...data,
        };
    }, [getContractData]);

    const formRef = useRef<typeof ContractUpdateForm>(null);

    return (
        <ProjectPageLayout
            isHeaderCollapsable
            title="Договор"
            breadCrumbsItems={breadCrumbsItems}
            headerBottom={
                <div className="tool-bar">
                    <ContractUpdateToolbar formRef={formRef} />
                </div>
            }
        >
            {(projectDataStatus === RequestStatus.FETCHING || getContractStatus === RequestStatus.FETCHING) && (
                <Loader />
            )}
            {projectDataStatus === RequestStatus.SUCCESS && getContractStatus === RequestStatus.SUCCESS && (
                <ContractUpdateForm
                    defaultValues={defaultValues}
                    ref={formRef}
                    makeContractDataRequest={makeContractDataRequest}
                />
            )}
        </ProjectPageLayout>
    );
};

ContractUpdate.displayName = 'ContractUpdate';
